import Actions from 'flow/actions';
import FavoritesResource from 'flow/api/favorites';

import {
    networkErrorDispatcher,
    httpGetErrorDispatcher,
} from 'flow/actions/app-actions';
import { FavoriteType } from 'flow/utils/favorite-utils';
import { fromJS } from 'immutable';

export const getFavorites = () => (dispatch) => {
    FavoritesResource.getFavorites(
        {
            onResult(json) {
                dispatch(receiveFavorites(json));
            },
            onError: httpGetErrorDispatcher(dispatch),
        },
        'contact',
        'desktop',
    );
};

export const createFavorite = (favorite) => (dispatch) => {
    FavoritesResource.createFavorite(
        {
            onResult(json) {
                dispatch(receiveFavorite(json));
            },

            onError: networkErrorDispatcher(dispatch),
        },
        favorite,
    );
};

export const createFavoriteQueue = (queueKey) => (dispatch, getState) => {
    const favoriteDTO = fromJS({
        type: FavoriteType.queue,
        queue: getState().pbx.getIn(['queues', queueKey]),
    });
    dispatch(createFavorite(favoriteDTO));
};

export const deleteFavorite = (favoriteEntityKey) => (dispatch) => {
    FavoritesResource.deleteFavorite(
        {
            onResult(/*json*/) {
                dispatch(updateDelete(favoriteEntityKey));
            },

            onError: networkErrorDispatcher(dispatch),
        },
        favoriteEntityKey,
    );
};

export const receiveFavorites = (favorites) => ({
    type: Actions.RESULT_FAVORITES,
    data: favorites,
});

export const receiveFavorite = (favorite) => ({
    type: Actions.RESULT_FAVORITE,
    data: favorite,
});

export const updateDelete = (favoriteEntityKey) => ({
    type: Actions.REMOVED_FAVORITE,
    key: favoriteEntityKey,
});
